import { render, staticRenderFns } from "./TermsFaqs.vue?vue&type=template&id=17df3dfe&scoped=true&"
import script from "./TermsFaqs.vue?vue&type=script&lang=js&"
export * from "./TermsFaqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17df3dfe",
  null
  
)

export default component.exports